import axios from "axios";
const CancelToken = axios.CancelToken;
const source = CancelToken.source();
export const cancelAxios = (reason) => {
  source.cancel(reason);
};
export default axios;
